import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
} from '@mui/material';
import { profileSectionStyles } from './ProfileSection.styles';

const ProfileSection = ({ title, icon, children, color = 'primary.main' }) => {
  return (
    <Card sx={profileSectionStyles.card}>
      <Box 
        sx={{
          ...profileSectionStyles.header,
          ...profileSectionStyles.getHeaderBackground(color),
        }}
      >
        <Box sx={profileSectionStyles.titleContainer}>
          <Box 
            sx={{
              ...profileSectionStyles.iconContainer,
              color: color,
            }}
          >
            {icon}
          </Box>
          <Typography variant="h6" sx={profileSectionStyles.title}>
            {title}
          </Typography>
        </Box>
      </Box>
      
      <CardContent sx={profileSectionStyles.content}>
        {children}
      </CardContent>
    </Card>
  );
};

export default ProfileSection; 